import { booleanContains, circle, point } from '@turf/turf'

export type Coordinates = {
  latitude: number
  longitude: number
}

export interface Location {
  latitude: number
  longitude: number
  radius: number
}

export const isInGeofence = (expectedLocation: Location | undefined, punchCoords: Coordinates | undefined): Boolean => {
  if (!expectedLocation || !punchCoords) return true
  if (typeof expectedLocation.longitude !== 'number' || typeof expectedLocation.latitude !== 'number' || typeof expectedLocation.radius !== 'number')
    return true
  if (typeof punchCoords.latitude !== 'number' || typeof punchCoords.latitude !== 'number') return true

  const center = [expectedLocation.longitude, expectedLocation.latitude]
  const radius = expectedLocation.radius
  const circlePolygon = circle(center, radius, {
    steps: 64,
    units: 'meters'
  })
  const punchCoordsPoint = point([punchCoords.longitude, punchCoords.latitude])

  return booleanContains(circlePolygon, punchCoordsPoint)
}

interface IsLocationConflicts {
  enablePunchGeolocation: Boolean
  arrival: string
  leave: string | undefined
  prevFlag: Boolean
  expectedLocation: Location | undefined
  punchCoords: Coordinates | undefined
}

export const isLocationConflicts = ({ enablePunchGeolocation, arrival, leave, prevFlag, expectedLocation, punchCoords }: IsLocationConflicts): Boolean => {
  if (!enablePunchGeolocation) return false
  if (leave) return prevFlag
  if (arrival && !leave && prevFlag) return true
  return !isInGeofence(expectedLocation, punchCoords)
}
